import React, { useContext, useState } from "react";
import { ShoppingCartContext } from "../components/ShoppingCartContext";
import "../css/CartSidebar.css";
import ic_added_to_cart_check_mark from "../img/ic_added_to_cart_check.png";
import { useNavigate } from "react-router-dom";
import ic_no_image from "../img/ic_no_image_available_big.png";

function CartSidebar(props) {

    // localStorage starts

    let initialLocalStorageOrderItems = localStorage.getItem("autoland_ordered_items")

    console.log("initialLocalStorageOrderItems ", initialLocalStorageOrderItems)

    let initialOrderArray = null;

    if (initialLocalStorageOrderItems != null) {
        initialOrderArray = JSON.parse(initialLocalStorageOrderItems)
    }

    const [localStorageOrderItems, setLocalStorageOrderItems] = useState(initialOrderArray)

    // localStorage ends

    const navigate = useNavigate()

    const { setShowCartSidebar, currentItemAddedToCart } = props;

    const { shoppingCart, setShoppingCart } = useContext(ShoppingCartContext)

    console.log("shoppingCart ", shoppingCart)

    const clickedOnCheckout = () => {
        navigate("/cart")
    }

    const addDefaultSrc = (ev) => {
        ev.target.style.display = 'none';
        console.log("ev.target.nextElementSibling  ", ev.target.nextElementSibling)

        //ev.target.nextElementSibling.src ="../img/ic_no_image_available_big.png"
        ev.target.nextElementSibling.style.display = 'block';
    }

    return (
        <div className="CartSidebar-root-container" >

            <div className="CartSidebar-left-container">

            </div>

            <div className="CartSidebar-right-container">
                <h4 className="m-4">Cart</h4>

                <p className="m-4 Cart-sidebar-added-to-cart-paragraph"> <img className="Cart-sidebar-added-to-cart-label me-2" src={ic_added_to_cart_check_mark} />Added to cart</p>
                {
                    currentItemAddedToCart != null &&
                    <div className="p-3">
                        <div className="Cart-sidebar-image-name-container">
                            <img className="Cart-sidebar-image" src={`http://autoland1.fortiddns.com:83/${currentItemAddedToCart.imgPath}`}
                                onError={(e) => addDefaultSrc(e)} />
                            <img className="Cart-sidebar-image-error" src={ic_no_image}
                            />
                            <div>
                                <label className="Cart-sidebar-product-code_name ms-2">{
                                    currentItemAddedToCart.Code
                                }</label>
                                <label className="Cart-sidebar-product-name ms-2">{
                                    currentItemAddedToCart.Description
                                }</label>
                            </div>
                        </div>
                        <div className="mt-3 Cart-sidebar-total-and-value">
                            <label className="Cart-sidebar-total-label">Cart Total</label>
                            <label className="ms-2">AED {localStorageOrderItems?.reduce((acc, curr) => {

                                return acc = acc + (curr.price * curr.quantity_in_shopping_cart)

                            }, 0)}</label>
                        </div>
                    </div>
                }
                <div className="Cart-sidebar-cta-container p-3">
                    <button className="btn btn-danger Cart-sidebar-checkout me-2" onClick={() => clickedOnCheckout()}>Checkout</button>
                    <button className="btn btn-success Cart-sidebar-continue-shopping" onClick={() => setShowCartSidebar(false)}>Continue Shopping</button>
                </div>
            </div>



        </div>
    )
}

export default CartSidebar;